import {REGSCREEN} from './m-types'

let screen = {
    state: {
        // content: [],
        content: [
            [ ['',0],
                [1,1]
            ], 
            [
                [ '', '' ], 
                [ '', '' ]
            ], 
            [ 
                [ '', '' ], 
                [ '', '' ] 
            ],
            [ 
                [ '', '' ], 
                [ '', '' ] 
            ],
            [ 
                [ '', '' ], 
                [ '', '' ] 
            ],
            [ 
                [ '', '' ], 
                [ '', '' ] 
            ],
            [ 
                [ '', '' ], 
                [ '', '' ] 
            ],
        ],
        from: '',
        behaviours: {}
    },
    mutations: {
        [REGSCREEN](state, newScreen){
            state.content = newScreen.content
            state.behaviours = newScreen.behaviours
        }
    },
    actions: {

    }
}

export {screen}


        // behaviours:{
        //     l1: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     l2: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     l3: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     l4: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     l5: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     l6: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     r1: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     r2: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     r3: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     r4: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     r5: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        //     r6: {
        //         navTo: '',
        //         reproduction: false,
        //         modify: false
        //     },
        // }